import React from 'react';

import { Field } from 'formik';

import '@app/scss/components/customCheckbox.scss';

export interface CustomCheckboxProps {
	isChecked: boolean;
	formikBag: any;
	capture: any;
	setIsChecked: (val: boolean) => void;
	className?: string;
	fieldName?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
	isChecked,
	formikBag,
	capture,
	setIsChecked,
	className = '',
	fieldName = 'isDisplayed',
}) => {
	return (
		<Field
			name={fieldName}
		>
			{() => {
				return (
					<div className={`custom-checkbox ${className}`}>
						<input
							id={fieldName}
							type="checkbox"
							checked={isChecked}
							onChange={() => {
								setIsChecked(!isChecked);
								formikBag.setFieldValue(fieldName, !isChecked);
							}}
						/>
						<label htmlFor={fieldName}>
							{capture}
						</label>
					</div>
				);
			}}
		</Field>
	);
};

export default CustomCheckbox;
